import React, { useState } from "react";
import type { Connector } from "../data/connectors";

type Props = { connector: Connector; size?: "normal" | "large" };

export const ConnectorLogo: React.FC<Props> = ({ connector, size="normal" }) => {
  const [failed, setFailed] = useState(false);
  const url = connector.localLogo || (connector.logoSlug
    ? "https://cdn.simpleicons.org/" + encodeURIComponent(connector.logoSlug) + "/" + encodeURIComponent(connector.color.replace(/^#/, ""))
    : "");
  return (
    <span className={"h-source-logo " + (size==="large"?"h-source-logo-large":"")}
      style={{ "--h-source-color": connector.color } as React.CSSProperties}>
      {!failed && url ? (
        <img loading="lazy" src={url} alt="" onError={()=>setFailed(true)} />
      ) : (
        <span aria-hidden="true">{connector.name.charAt(0)}</span>
      )}
    </span>
  );
};
